import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { Trip } from '../models/dto'
import TripMap from '@/components/TripMap.vue'
import TripItineraryV2 from '@/components/TripItineraryV2.vue'
import { TripItineraryV2Stop } from '@/models/ItineraryStop'
import { getTripItineraryStopsFromTrip } from '@/utils/tripItinerary'


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutTripItinerary',
  props: {
    trip: null
  },
  setup(__props: any) {

const props = __props as { trip: Trip };



const itineraryStops = computed<TripItineraryV2Stop[]>(() => getTripItineraryStopsFromTrip(props.trip))

return { __sfc: true,props, itineraryStops, TripMap, TripItineraryV2 }
}

})